// src/Pages/Landing/JoyrideVarsinaisSuomiLanding.jsx
import React from "react";
import JoyrideMaakuntaLanding from "./JoyrideMaakuntaLanding.jsx";

export default function JoyrideVarsinaisSuomiLanding() {
  return (
    <JoyrideMaakuntaLanding
      maakunta="Varsinais-Suomi"
      cities={[
        "Turku",
        "Kaarina",
        "Raisio",
        "Naantali",
        "Salo",
        "Lieto",
        "Paimio"
      ]}
      regionText="Bilebändi Joyride tekee keikkoja myös Varsinais-Suomen alueelle tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Turun seutu ja lähikunnat sopivat hyvin esimerkiksi häihin, yritysjuhliin, kesäjuhliin ja pikkujouluihin, kun juhliin halutaan energinen livebändi."
      bookingLink="/#varaa"
    />
  );
}